import { S } from './ShimmerAnimation.styles';
import type { ShimmerAnimationProps } from './ShimmerAnimation.types';

export const ShimmerAnimation = (props: ShimmerAnimationProps) => <S.ShimmerAnimation {...props} />;
